<template>
  <div>
    <div class="mb-3">
      <div class="font-size-title font-weight-regular mb-3">選擇店家</div>
      <div>
        <div
          v-for="(storeClass, i) in storeClassList"
          class="m-r-5 m-b-10 inline-block"
          :key="`store-class-${i}`"
        >
          <button
            class="btn btn-default"
            :class="{
              'active': curId === storeClass.id
            }"
            @click="clickOption(storeClass)"
            v-text="storeClass.name"
          />
        </div>
      </div>
    </div>
    <v-multiselect-listbox
      v-model="setting.choose"
      class="col-xs-12"
      :options="setting.options"
      :reduce-display-property="(option) => option.label"
      :reduce-value-property="(option) => option.value"
      search-options-placeholder="搜尋..."
      selected-options-placeholder="搜尋..."
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'nd-multi-select-listbox',
  props: {
    brandId: {
      type: Number,
      default: 0
    },
    getDataH: {
      type: Function
    },
    storeId: {
      type: Number,
      default: 0
    },
    /**
     * 1: allow_copy_menu
     */
    type: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      curId: 0,
      info: {
        brandId: 0,
        storeId: 0
      },
      setting: {
        class: 'copy-store',
        options: [],
        choose: []
      },
      stores: [],
      storeClass: [],
      storeClassList: []
    }
  },
  computed: {
    ...mapGetters(['getRoleType'])
  },
  watch: {
    'setting.choose' (val) {
      this.$emit('update:choose', val)
    }
  },
  mounted () {
    setTimeout(() => {
      this.info.brandId = this.brandId
      this.info.storeId = this.storeId
      this.getInfo()
    }, 100)
  },
  methods: {
    async clickOption (option) {
      this.curId = option.id
      if (this.curId) {
        await this.getStoreClass()
        this.updataChoose()
      }
    },
    formatData () {
      for (let i = 0; i < this.stores.length; i++) {
        let temp = {
          label: this.stores[i].name,
          value: this.stores[i].store_id
        }
        if (parseInt(this.stores[i].store_id, 10) !== parseInt(this.brandId, 10)) {
          this.setting.options.push(temp)
        }
      }
    },
    getBrandList () {
      return new Promise((resolve, reject) => {
        if (this.info.brandId) {
          resolve()
          return
        }
        const url = '/brand/list?page=1&size=1'
        this.getDataH('get', url, null, (res) => {
          if (res.data.status === 200) {
            this.info.brandId = res.data.list[0].id
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    async getInfo () {
      await this.getBrandList()
      await this.getStoreListBrief()
      await this.getStoreClassList()
      this.formatData()
    },
    getStoreClass () {
      return new Promise((resolve, reject) => {
        const url = `brand/${this.info.brandId}/storeClass/${this.curId}`
        this.getDataH('get', url, null, (res) => {
          if (res.data.status === 200) {
            this.storeClass = res.data.class
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    getStoreListBrief () {
      console.log({
        component: this.$options.name,
        function: 'getStoreListBrief',
        payload: {},
        time: moment().format('HH:mm:ss')
      })
      return new Promise((resolve, reject) => {
        this.stores = []
        this.setting.options = []
        let url = `/brand/${this.info.brandId}/storeListBrief`
        if (url.indexOf('?') === -1) {
          url = url + '?'
        }
        let temp = []
        if (this.type === 1) {
          temp.push('allow_copy_menu=1')
        }
        if (this.info.storeId) {
          temp.push('store_ids=' + this.info.storeId)
        }

        url = url + temp.join('&')
        this.getDataH('get', url, null, (response) => {
          if (response.data.status === 200) {
            this.stores = response.data.list
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    getStoreClassList () {
      return new Promise((resolve, reject) => {
        // 門市權限 | 不需要取得群組列表
        if (this.getRoleType === 10) {
          resolve()
          return
        }
        const url = `brand/${this.info.brandId}/storeClassList`
        this.getDataH('get', url, null, (res) => {
          if (res.data.status === 200) {
            this.storeClassList = res.data.list
            resolve()
          } else {
            reject()
          }
        })
      })
    },
    updataChoose () {
      this.setting.choose = []
      this.storeClass.store_list.forEach((i) => {
        const storeIndex = this.stores.findIndex((store) => {
          return i.id === store.store_id
        })
        if (storeIndex !== -1) {
          this.setting.choose.push(i.id)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.font-size-title {
  font-size: 18px;
}
.font-weight-regular {
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// nd-multi-select-listbox.vue?547e7df7